import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAcs } from '@obvious.tech/constellation'

export const Acs = defineEntity('Acs', {
  endpoint: 'accesscontrol/api/Acs',
  schema: SNoop<IAcs>(),
})
